module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 144);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@splunk/themes");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ src_ModalLayer_ModalLayer; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "@splunk/react-ui/Animation"
var Animation_ = __webpack_require__(30);

// EXTERNAL MODULE: external "@splunk/react-ui/Layer"
var Layer_ = __webpack_require__(49);
var Layer_default = /*#__PURE__*/__webpack_require__.n(Layer_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(3);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "react-spring"
var external_react_spring_ = __webpack_require__(18);

// EXTERNAL MODULE: external "@splunk/themes"
var themes_ = __webpack_require__(0);

// CONCATENATED MODULE: ./src/ModalLayer/ModalLayerStyles.ts



var overlay = Object(external_styled_components_["css"])(["", ";position:fixed;top:0;right:0;bottom:0;left:0;"], themes_["mixins"].reset('block'));
var StyledClickAwayOverlay = external_styled_components_default()(external_react_spring_["animated"].div).withConfig({
  displayName: "ModalLayerStyles__StyledClickAwayOverlay",
  componentId: "sc-1sa3n1j-0"
})(["", ";background-color:", ";z-index:", ";"], overlay, themes_["variables"].backgroundColorScrim, themes_["variables"].zindexModalBackdrop);

// CONCATENATED MODULE: ./src/ModalLayer/ModalLayer.tsx
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var propTypes = {
  childrenInAnimation: external_prop_types_default.a.bool,
  getDefaultMotionStyle: external_prop_types_default.a.func,
  getMotionStyle: external_prop_types_default.a.func,
  onRequestClose: external_prop_types_default.a.func,
  open: external_prop_types_default.a.bool,
  renderModal: external_prop_types_default.a.func.isRequired,
  useLayerForClickAway: external_prop_types_default.a.bool
};
var defaultProps = {
  childrenInAnimation: false,
  open: false,
  useLayerForClickAway: true
};

var ModalLayer_ModalLayer = /*#__PURE__*/function (_Component) {
  _inherits(ModalLayer, _Component);

  var _super = _createSuper(ModalLayer);

  function ModalLayer(props) {
    var _this;

    _classCallCheck(this, ModalLayer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClickAway", function (event) {
      var _this$props$onRequest, _this$props;

      (_this$props$onRequest = (_this$props = _this.props).onRequestClose) === null || _this$props$onRequest === void 0 ? void 0 : _this$props$onRequest.call(_this$props, {
        reason: 'clickAway',
        event: event
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAnimationEnd", function () {
      _this.setState({
        animating: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderLayer", function () {
      var _this$props2 = _this.props,
          getDefaultMotionStyle = _this$props2.getDefaultMotionStyle,
          getMotionStyle = _this$props2.getMotionStyle,
          renderModal = _this$props2.renderModal,
          useLayerForClickAway = _this$props2.useLayerForClickAway;
      var open = _this.props.open || _this.state.animating;
      return /*#__PURE__*/external_react_default.a.createElement(Animation_["Spring"], {
        from: _objectSpread(_objectSpread({}, getDefaultMotionStyle === null || getDefaultMotionStyle === void 0 ? void 0 : getDefaultMotionStyle()), {}, {
          overlayOpacity: 0,
          opacity: 0
        }),
        to: _objectSpread(_objectSpread({}, getMotionStyle === null || getMotionStyle === void 0 ? void 0 : getMotionStyle()), {}, {
          overlayOpacity: _this.props.open ? 1 : 0,
          opacity: _this.props.open ? 1 : 0
        }),
        onRest: _this.handleAnimationEnd
      }, function (interpolatedStyle) {
        return /*#__PURE__*/external_react_default.a.createElement("div", null,
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        renderModal(interpolatedStyle), open && useLayerForClickAway && /*#__PURE__*/external_react_default.a.createElement(StyledClickAwayOverlay, {
          onMouseDown: _this.handleClickAway,
          key: "clickAway",
          style: {
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            opacity: interpolatedStyle.overlayOpacity
          }
        }));
      });
    });

    _this.state = {
      animating: false,
      prevOpen: props.open // eslint-disable-line react/no-unused-state

    };
    return _this;
  }

  _createClass(ModalLayer, [{
    key: "render",

    /* eslint-enable jsx-a11y/no-static-element-interactions */
    value: function render() {
      var open = this.props.open || this.state.animating || this.props.childrenInAnimation;
      return /*#__PURE__*/external_react_default.a.createElement(Layer_default.a, {
        open: open,
        closeReasons: ['escapeKey'],
        onRequestClose: this.props.onRequestClose
      }, open && this.renderLayer());
    }
  }]);

  return ModalLayer;
}(external_react_["Component"]);

_defineProperty(ModalLayer_ModalLayer, "propTypes", propTypes);

_defineProperty(ModalLayer_ModalLayer, "defaultProps", defaultProps);

_defineProperty(ModalLayer_ModalLayer, "getDerivedStateFromProps", function (props, state) {
  if (props.open !== state.prevOpen) {
    return {
      animating: true,
      prevOpen: props.open
    };
  }

  return null;
});

/* harmony default export */ var src_ModalLayer_ModalLayer = (ModalLayer_ModalLayer);
// CONCATENATED MODULE: ./src/ModalLayer/index.ts



/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = require("react-spring");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Animation");

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Layer");

/***/ })

/******/ });